import { Typography } from "@material-ui/core";
import { IAuditLogEntry } from "../../../../types";

export const LocationAuditDelete = ({ oldData }: IAuditLogEntry) => {
  return <Typography>Deleted the Location "{oldData.name}"</Typography>;
};

export default LocationAuditDelete;
